module.exports = "p {\n  font-family: 'Arial';\n}\n/*# sourceMappingURL=src/app/static/funnel/funnel.component.css.map */"